import HomeLayout from 'layouts/home-layout';

import { IntegrationList } from './components/integration-list';
export const IntegrationsPage = () => {
  return (
    <HomeLayout showPortalName={true}>
      <div>
        <IntegrationList />
        {
          // webhook list
        }
      </div>
    </HomeLayout>
  );
};
